import { render, staticRenderFns } from "./CustomerItems.vue?vue&type=template&id=1b2ad9e4&scoped=true"
import script from "./CustomerItems.vue?vue&type=script&lang=js"
export * from "./CustomerItems.vue?vue&type=script&lang=js"
import style0 from "./CustomerItems.vue?vue&type=style&index=0&id=1b2ad9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ad9e4",
  null
  
)

export default component.exports